import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SubBanner from '../components/SubBanner';
import ModularBlocks from '../components/ModularBlocks';

const DefaultPageTemplate = ({ data: { datoCmsPage } }) => {
  const {
    seoMetaTags,
    noIndex,
    title,
    bannerHeading,
    bannerText,
    bannerLink,
    bannerImage,
    bannerPardotFormUrl,
    bannerPardotFormHeight,
    modularBlocks,
  } = datoCmsPage;

  return (
    <Layout seo={seoMetaTags} noIndex={noIndex} page={datoCmsPage}>
      <main>
        <SubBanner
          heading={bannerHeading || title}
          text={bannerText}
          link={bannerLink}
          image={bannerImage}
          pardotFormUrl={bannerPardotFormUrl}
          pardotFormHeight={bannerPardotFormHeight}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export const DefaultPageTemplateQuery = graphql`
  query DefaultPageTemplateQuery($id: String!) {
    datoCmsPage(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      noIndex
      title
      bannerHeading
      bannerText {
        value
      }
      bannerLink {
        text
        pageUrl {
          ...LinkFragment
        }
      }
      bannerImage {
        url
        alt
      }
      bannerPardotFormUrl
      bannerPardotFormHeight
      modularBlocks {
        ...AccordionModularBlockFragment
        ...CallToActionModularBlockFragment
        ...CallToActionStripModularBlockFragment
        ...CareersModularBlockFragment
        ...ContactFormModularBlockFragment
        ...ContainedImageModularBlockFragment
        ...ContentModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...FaqsModularBlockFragment
        ...FeaturedBlogPostsModularBlockFragment
        ...FeaturedCaseStudiesModularBlockFragment
        ...FeaturedEbooksModularBlockFragment
        ...FeaturedLogosModularBlockFragment
        ...FeaturedResourceModularBlockFragment
        ...FeaturedResultsModularBlockFragment
        ...FeaturedReviewsModularBlockFragment
        ...FeaturedStatisticsModularBlockFragment
        ...FeaturedStepsModularBlockFragment
        ...FeaturedToolsModularBlockFragment
        ...FileDemosModularBlockFragment
        ...FullWidthImageModularBlockFragment
        ...HighlightedContentModularBlockFragment
        ...HtmlModularBlockFragment
        ...IconContentBlocksModularBlockFragment
        ...ImageContentBlocksModularBlockV1Fragment
        ...ImageContentBlocksModularBlockV2Fragment
        ...ImageContentCardsModularBlockFragment
        ...ImageContentCardsModularBlockIllustrationFragment
        ...ImageContentModularBlockV1Fragment
        ...ImageContentModularBlockIllustrationFragment
        ...ImageContentModularBlockV2Fragment
        ...InternalVideoModularBlockFragment
        ...MapLocationsModularBlockFragment
        ...NewsletterSignupModularBlockFragment
        ...PlansModularBlockFragment
        ...ServicesModularBlockFragment
        ...TableModularBlockFragment
        ...TabsModularBlockFragment
        ...TeamProfilesModularBlockFragment
        ...TestimonialModularBlockFragment
      }
      ...LinkFragment
    }
  }
`;

export default DefaultPageTemplate;
